import React, { useState } from 'react'

import { Box, Button } from '@mui/material'

import ContentUnavailable from '../../components/ContentUnavailable'

import './styles.css'

const OptionsExamples = (props) => {
    return {
        option1: {
            permissions: true,
            label: 'Opção1',
            component: (<Box {...props}></Box>)
        }
    }
}

const selectFirstMenu = (componentName, options) => {
    const nameOnStorage = localStorage.getItem(`${componentName}-menu`)

    if (nameOnStorage && options[nameOnStorage]?.permissions) {
        return nameOnStorage
    }

    return Object.keys(options).find(
        key => options[key]?.permissions
    )
}

const OptionsMenu = ({
    title,
    name,
    options = () => {},
    drillProps = null
}) => {

    const getOptions = options(drillProps)

    const [selectedTab, setSelectedTab] = useState(
        selectFirstMenu(name, getOptions)
    )

    const changeTab = (key) => {
        localStorage.setItem(`${name}-menu`, key)
        setSelectedTab(key)

        if (window?.returnSettings) {
            window.returnSettings()
        }
    }

    const selectedOption = getOptions[selectedTab]

    const renderContent = () => {
        if (! selectedOption?.permissions) {
            return null
        }

        if (! selectedOption.isAvailable) {
            return (
                <ContentUnavailable
                    icon={selectedOption.unavailable?.icon}
                    title={selectedOption.unavailable?.title}
                    description={selectedOption.unavailable?.description}
                />
            )
        }

        return selectedOption.component
    }

    return (
        <Box className='BuilderContainer'>
            <Box className='BuilderSelectorContainer'>
                {title ? (
                    <Box className='options-menu-title'>
                        {title}
                    </Box>
                ) : null}

                <Box className='BuilderSelectorBox'>
                    {Object.entries(getOptions).map(([key, value]) => (
                        value?.permissions ? (
                            <Button
                                key={key}
                                variant={
                                    key === selectedTab
                                        ? 'contained'
                                        : ''
                                }
                                onClick={() => changeTab(key)}
                            >
                                {value?.label}
                                {value?.icon && value.icon}
                            </Button>
                        ) : null
                    ))}
                </Box>
            </Box>

            <Box className='BuilderContent'>
                {renderContent()}
            </Box>
        </Box>
    )
}

export default OptionsMenu